import store from '../../store';
import Errors from '../../Errors';
//import ComboRating from '../ComboRating.vue';
import ComboCardMixin from '../../mixins/ComboCardMixin';
import RelatedCombos from './show/RelatedCombos.vue';

export default {
    components: {  RelatedCombos },//ComboRating,

    mixins: [
        ComboCardMixin,
    ],

    props: ['combo'], //, 'reviewCount', 'avgRating'

    data() {
        return {
            price: this.combo.formatted_price,
            activeTab: 'description',
            //currentReviewPage: 1,
            //fetchingReviews: false,
            //reviews: {},
            //addingNewReview: false,
            //reviewForm: {},
            cartItemForm: {
                combo_id: this.combo.id,
                qty: 1,
                combo_product_option_combinations: {},
            },
            errors: new Errors(),
        };
    },

    computed: {
/*        totalReviews() {
            if (! this.reviews.total) {
                return this.reviewCount;
            }

            return this.reviews.total;
        },

        ratingPercent() {
            return (this.avgRating / 5) * 100;
        },

        emptyReviews() {
            return this.totalReviews === 0;
        },

        totalReviewPage() {
            return Math.ceil(this.reviews.total / 4);
        },*/
    },

    created() {
        //this.fetchReviews();
    },

    mounted() {
        $(this.$refs.upSellCombos).slick({
            rows: 0,
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            rtl: window.FleetCart.rtl,
        });

        if($('.li-option-combination-first').length > 0){
            //$('#list-option-combination-0 li:first').click();
            $('.li-option-combination-first').click();
        }
    },

    methods: {
        updateQuantity(qty) {
            if (qty < 1 || this.exceedsMaxStock(qty)) {
                return;
            }

            if (isNaN(qty)) {
                qty = 1;
            }

            this.cartItemForm.qty = qty;
        },

        exceedsMaxStock(qty) {
            return this.combo.manage_stock && this.combo.qty < qty;
        },

/*        changeReviewPage(page) {
            this.currentReviewPage = page;

            this.fetchReviews();
        },*/

        updatePrice() {
            this.$nextTick(() => {
                $.ajax({
                    method: 'POST',
                    url: route('combos.price.show', { id: this.combo.id }),
                    data: { combo_product_option_combinations: this.cartItemForm.combo_product_option_combinations },
                }).then((price) => {
                    this.price = price;
                }).catch((xhr) => {
                    this.$notify(xhr.responseJSON.message);
                });
            });
        },

        optionCombinationValueIsActive(comboProductId, productOptionCombinationId) {
            if (! this.cartItemForm.combo_product_option_combinations.hasOwnProperty(comboProductId)) {
                return false;
            }

            return this.cartItemForm.combo_product_option_combinations[comboProductId] === productOptionCombinationId;
        },

        changeOptionCombinationValue(comboProductId, comboProductOptionCombinationId) {

            if (this.optionCombinationValueIsActive(comboProductId, comboProductOptionCombinationId)) {
                this.$delete(this.cartItemForm.combo_product_option_combinations, comboProductId);
            } else {
                this.$set(this.cartItemForm.combo_product_option_combinations, comboProductId, comboProductOptionCombinationId);

                this.errors.clear(`combo_product_option_combinations.${comboProductId}`);
            }
        },

        checkIfOptionCombinationIsSelected(comboProductId, comboProductOptionCombinationId) {
            if (! this.cartItemForm.combo_product_option_combinations.hasOwnProperty(comboProductId)) {
                return false;
            }

            return this.cartItemForm.combo_product_option_combinations[comboProductId] === comboProductOptionCombinationId;
        },

        addToCart() {
 
            this.addingToCart = true;
            
            $.ajax({
                method: 'POST',
                url: route('cart.items.store', this.cartItemForm),
            }).then((cart) => {
                console.log(cart)   
                store.updateCart(cart);

                $('.header-cart').trigger('click');
            }).catch((xhr) => {
                if (xhr.status === 422) {
                    this.errors.record(xhr.responseJSON.errors);
                } else {
                    this.$notify(xhr.responseJSON.message);
                }
            }).always(() => {
                this.addingToCart = false;
            });
        },
    },
};
